import type { Icon } from '@phosphor-icons/react';
import {
  ScalesIcon,
  BookIcon,
  ShieldCheckIcon,
  HardHatIcon,
  ChatTeardropTextIcon,
  GraduationCapIcon,
  BuildingsIcon,
  FileTextIcon
} from '@phosphor-icons/react';
import { DocumentAuthority } from 'src/lib/types';

export const AUTHORITY_OPTIONS: Array<{ label: string; value: DocumentAuthority }> = [
  { label: 'Law', value: 'law' },
  { label: 'Statutory Code', value: 'statutory_code' },
  { label: 'Official Guidance', value: 'official_guidance' },
  { label: 'Industry Guidance', value: 'industry_guidance' },
  { label: 'Informal Guidance', value: 'informal_guidance' },
  { label: 'Learning Resource', value: 'learning_resource' },
  { label: 'Local Policy', value: 'local_policy' }
];

const AUTHORITY_ICONS: Record<DocumentAuthority, Icon> = {
  law: ScalesIcon,
  statutory_code: BookIcon,
  official_guidance: ShieldCheckIcon,
  industry_guidance: HardHatIcon,
  informal_guidance: ChatTeardropTextIcon,
  learning_resource: GraduationCapIcon,
  local_policy: BuildingsIcon
};

export const getAuthorityIcon = (authority: string): Icon => {
  return AUTHORITY_ICONS[authority as DocumentAuthority] ?? FileTextIcon;
};

export const DOCUMENT_AUTHORITY_DESCRIPTIONS: Partial<Record<DocumentAuthority, string>> = {
  law: 'Binding legislation and regulation enacted by Parliament or made under statutory authority, with which compliance is mandatory.',
  statutory_code:
    'Guidance/code issued under a specific statutory power that legislation requires public bodies, courts, or decision-makers to have regard to or follow.',
  official_guidance:
    'Guidance issued by a government department, regulator, or statutory public body in the exercise of its official functions, but not under a specific statutory "have regard" duty.',
  industry_guidance:
    'Guidance formally produced or endorsed by a recognised professional body, trade association, or sector representative organisation, or manufacturer to direct practice within that field.',
  informal_guidance:
    'Guidance produced by organisations or individuals without formal governmental or sector-wide authority.',
  learning_resource: 'Other informational resources that do not seek to direct conduct (e.g. HEJ).',
  local_policy: 'Policies, protocols, or procedures issued by a local organisation for its own operations.'
};

export const getDocumentAuthorityDescription = (authority?: string | DocumentAuthority | null): string | null => {
  if (!authority) return null;
  return DOCUMENT_AUTHORITY_DESCRIPTIONS[authority as DocumentAuthority] || null;
};

export const formatDocumentAuthorityLabel = (authority?: string | DocumentAuthority | null): string => {
  if (!authority) return '';
  const formatted = authority
    .toLowerCase()
    .split('_')
    .map((part) => part)
    .join(' ');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
